import React from "react";
import { Header, Message, Segment, List, Image } from "semantic-ui-react";

const Tokens = () => {
  const imageStyle = {
    border: "1px solid #ccc",
    padding: "1em",
    borderRadius: "5px",
  };

  return (
    <>
      <Header as="h3">Overview</Header>
      <p>
        This section provides guidelines on how to generate and use the API
        Tokens.
      </p>
      <Segment padded>
        <Header as="h4">Bearer Token</Header>
        <p>
          The API requires a bearer token for authentication. This token should
          be included in the Authorization header of your requests.
        </p>
      </Segment>
      <Message warning>
        <Message.Header>Token responsibility</Message.Header>
        <p>
          The bearer token is a sensitive piece of information that should be
          kept secure. It is used to authenticate API requests and should not be
          shared or exposed in public repositories or client-side code.
        </p>
        <p>
          You as the user are responsible for managing the security of your
          generated tokens.
        </p>
      </Message>
      <Segment padded>
        <Header as="h4">How to generate your token</Header>
        <List ordered>
          <List.Item>
            <p>
              On the right top side of the page, click on your email to open
              profile menu and click the <strong>"Applications"</strong> option.
            </p>
            <Image
              src="/static/images/profile_menu.png"
              alt="Profile menu"
              style={imageStyle}
            />
          </List.Item>
          <List.Item>
            <p>
              Locate and click the <strong>New Token</strong> button.
            </p>
            <Image
              src="/static/images/token_add.png"
              alt="Token add"
              style={imageStyle}
            />
          </List.Item>
          <List.Item>
            <p>
              On the next page, fill the <strong>name</strong> field and hit the{" "}
              <strong>Create</strong> button.
            </p>
            <Image
              src="/static/images/token_create.png"
              alt="Token create"
              style={imageStyle}
            />
          </List.Item>
          <List.Item>
            <p>
              The following page will show you the generated token, but only{" "}
              <strong>once</strong>. If you leave this page, you will not be
              able to see the token again and you will have to create a new one.
            </p>
            <p>
              This page also allows you to edit the token name or delete it if
              you no longer need it. It is available from the{" "}
              <strong>Applications</strong> page, when you click on specific
              token.
            </p>
            <Image
              src="/static/images/token_edit.png"
              alt="Token edit"
              style={imageStyle}
            />
          </List.Item>
          <List.Item>
            <p>
              The token is now generated and you can use it in your API header
              as follows: <strong>Authorization: Bearer token_value</strong>
            </p>
          </List.Item>
        </List>
      </Segment>
    </>
  );
};

export default Tokens;
